import { ModelCollection } from '/@/modules/core/app/models/ModelCollection';
import { EstateTask } from '/@/modules/estatetask/models/EstateTask';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ModelType } from '@/modules/core/app/constants/ModelType';
import { UrlQueryOperator } from '@/modules/core/app/constants/UrlQueryOperator';

export abstract class EstateTaskFilterCollection<T extends EstateTask> extends ModelCollection<T> {
  protected constructor(
    items: Partial<T>[] | ModelCollection<T> | null | undefined,
    model: typeof BaseModel & (new (model?: Partial<T> | undefined) => T)
  ) {
    super(items, model);
  }

  get tasksToday(): T[] {
    return this.items?.filter((task: T) => task.isDueToday) ?? [];
  }

  get tasksThisWeek(): T[] {
    return this.items?.filter((task: T) => task.isDueThisWeek) ?? [];
  }

  get tasksNextWeek(): T[] {
    return this.items?.filter((task: T) => task.isDueNextWeek) ?? [];
  }

  getTasksToday(): this {
    // @ts-ignore
    return this.constructor.mapModel(this.items?.filter((task: T) => task.isDueToday) ?? []);
  }

  getTasksThisWeek(): this {
    // @ts-ignore
    return this.constructor.mapModel(this.items?.filter((task: T) => task.isDueThisWeek) ?? []);
  }

  getTasksNextWeek(): this {
    // @ts-ignore
    return this.constructor.mapModel(this.items?.filter((task: T) => task.isDueNextWeek) ?? []);
  }

  getTasksByUser(userId: number): this {
    // @ts-ignore
    return this.constructor.mapModel(this.items?.filter((task: T) => task.isByUser(userId)) ?? []);
  }

  getUnassignedTasks(): this {
    // @ts-ignore
    return this.constructor.mapModel(this.items?.filter((task: T) => !task.userId) ?? []);
  }

  getTasksCreatedByUser(userId: number, operator: string): this {
    return operator === UrlQueryOperator.EQUAL_TO.key
      ? // @ts-ignore
        this.constructor.mapModel(
          this.items?.filter(
            (task: T) => task.createdById === userId && task.createdByType === ModelType.USER
          ) ?? []
        )
      : // @ts-ignore
        this.constructor.mapModel(
          this.items?.filter(
            (task: T) => task.createdById !== userId && task.createdByType === ModelType.USER
          ) ?? []
        );
  }

  getTasksWithStatus(status: string, operator: string): this {
    return operator === UrlQueryOperator.EQUAL_TO.key
      ? // @ts-ignore
        this.constructor.mapModel(this.items?.filter((task: T) => task.status === status) ?? [])
      : // @ts-ignore
        this.constructor.mapModel(this.items?.filter((task: T) => task.status !== status) ?? []);
  }
  getTasksWithPriority(priority: string, operator: string): this {
    return operator === UrlQueryOperator.EQUAL_TO.key
      ? // @ts-ignore
        this.constructor.mapModel(this.items?.filter((task: T) => task.priority === priority) ?? [])
      : // @ts-ignore
        this.constructor.mapModel(
          this.items?.filter((task: T) => task.priority !== priority) ?? []
        );
  }
}
